module.exports = __webpack_public_path__ + "img/filedetail.1233e307.jpg";